import type { ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useViewMode } from '../../context/ViewModeContext';

interface SplitPanelLayoutProps {
  panelOpen: boolean;
  onClosePanel: () => void;
  listContent: ReactNode;
  panelContent: ReactNode | null;
}

export function SplitPanelLayout({
  panelOpen,
  onClosePanel,
  listContent,
  panelContent,
}: SplitPanelLayoutProps) {
  const { isMobile } = useViewMode();

  if (isMobile) {
    return (
      <div className="bg-white rounded-lg shadow">
        {/* List — hidden when panel is open */}
        <div className={`p-3 ${panelOpen ? 'hidden' : ''}`}>{listContent}</div>
        {/* Panel — full-width with back button */}
        {panelOpen && panelContent && (
          <div className="min-h-[60vh]">
            <button
              onClick={onClosePanel}
              className="flex items-center gap-1 px-3 py-2 text-sm text-primary-600 hover:text-primary-700"
            >
              <ArrowLeft size={16} />
              Back to list
            </button>
            {panelContent}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="flex gap-0 bg-white rounded-lg shadow">
      <div
        className={`${panelOpen ? 'w-[55%]' : 'w-full'} p-4 transition-all overflow-auto`}
        style={panelOpen ? { maxHeight: 'calc(100vh - 160px)' } : undefined}
      >
        {listContent}
      </div>
      {panelOpen && panelContent && (
        <div
          className="w-[45%] sticky top-0 overflow-auto border-l border-gray-200"
          style={{ maxHeight: 'calc(100vh - 160px)' }}
        >
          {panelContent}
        </div>
      )}
    </div>
  );
}
